import { requestActions } from "./utils";

export const SIGNUP_INFO = requestActions("Auth/Signup/Info");
export const SIGNUP_SUBMIT = requestActions("Auth/Signup/Submit");
